export default {
  getQuestionnaireData({ commit, dispatch, rootState, state }, query) {
    const questionnaireId = query.id;
    return dispatch(
      "get",
      {
        url: "/provider/" + state.id + "/survey/" + id + "?limit=100",
      },
      {
        root: true,
      }
    )
      .then((response) => {
        commit("finishLoadingRecords", id);
        let responseRecord = response.record
          ? response.record.record.filter((record) => record.completed)
          : [];
        Vue.set(state.record.survey, id, response.record.record);
        commit("content/cache", response.content, { root: true });
        return response;
      })
      .catch((error) => {
        commit("finishLoading");
        console.log(error);
        throw error;
      });
  },
  addFlagging({ commit, dispatch, state, rootState }, query) {
    let patientId = query.patientId
    let id = query.id
    delete query.patientId
    delete query.id
    return dispatch(
      "patch",
      {
        url:
          "/provider/" +
          rootState.provider.id +
          "/patient/" +
          patientId +
          "/survey/" +
          id,
        data: {
          ...query,
        },
      },
      { root: true }
    )
      .then((response) => {
        commit(
          "provider/updateSurveyRecord",
          {
            questionnaire: id,
            surveyList: response.survey,
          },
          { root: true }
        );
        return response
      })
      .catch((err) => {
        console.log(err);
      });
  },
  resolveFlagging({ commit, dispatch, rootState }, query) {
    return dispatch(
      "patch",
      {
        url:
          "/provider/" +
          rootState.provider.id +
          "/patient/" +
          query.patient +
          "/survey/" +
          query.survey,
        data: {
          question_id: query.question_id,
          problem_id: query.problem_id,
          auth: query.auth,
          type: "resolution",
        },
      },
      { root: true }
    )
      .then((response) => {
        commit(
          "provider/updatePatient",
          {
            id: query.patient,
            survey: [response],
          },
          { root: true }
        );
      })
      .catch((err) => {
        console.log(err);
      });
  },
  setPatientList({ commit }, query) {
    commit("setPatientList", query);
  },
  removePatientList({ commit }, key) {
    commit("removePatientList", key);
  },
};
